module.exports = __webpack_public_path__ + "img/btn-eye.aa35b6a4.svg";